import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import "@/App.css";
import Sidebar from "@/components/layout/Sidebar";
import MobileDrawer from "@/components/layout/MobileDrawer";
import TopBar from "@/components/layout/TopBar";
import Inicio from "@/pages/Inicio";
import Hierarquia from "@/pages/Hierarquia";
import Ranks from "@/pages/Ranks";
import Regras from "@/pages/Regras";
import RegrasPago from "@/pages/RegrasPago";
import Formulario from "@/pages/Formulario";
import Admin from "@/pages/Admin";
import AdminPanel from "@/pages/AdminPanel";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function Shell() {
    const location = useLocation();
    const [drawerOpen, setDrawerOpen] = useState(false);
    useEffect(() => setDrawerOpen(false), [location.pathname]);

    return (
        <div className="App min-h-screen bg-[#0A0C10] text-gray-100">
            <div className="noise-overlay" />
            <Sidebar />
            <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
            <div className="lg:pl-64">
                <TopBar onMenu={() => setDrawerOpen(true)} />
                <AnimatePresence mode="wait">
                    <Routes location={location} key={location.pathname}>
                        <Route path="/" element={<Inicio />} />
                        <Route path="/hierarquia" element={<Hierarquia />} />
                        <Route path="/ranks" element={<Ranks />} />
                        <Route path="/regras" element={<Regras />} />
                        <Route path="/regras-pago" element={<RegrasPago />} />
                        <Route path="/formulario-staff" element={<Formulario />} />
                        <Route path="/formulario/:formId" element={<Formulario />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/admin/painel" element={<AdminPanel />} />
                        <Route path="*" element={<Inicio />} />
                    </Routes>
                </AnimatePresence>
                <footer
                    data-testid="site-footer"
                    className="border-t border-white/[0.06] px-6 py-6 text-center"
                >
                    <p className="font-code text-[10px] uppercase tracking-[0.3em] text-gray-600">
                        EQUIPE STAFF [EBH1] — Escola Staff & Comunidade Roblox
                    </p>
                    <Link
                        to="/admin"
                        data-testid="admin-login-link"
                        className="mt-2 inline-flex items-center gap-1.5 text-[11px] font-semibold text-gray-600 transition-colors hover:text-violet-400"
                    >
                        Administração
                    </Link>
                </footer>
            </div>
        </div>
    );
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollToTop />
            <Shell />
        </BrowserRouter>
    );
}
